import { createSlice } from "@reduxjs/toolkit";
import { BookMarkData } from "../../../Data/Layout/HeaderData";
import { BookmarkedDataType, LayoutStateProps } from "../../../Types/LayoutType";

const initialState: LayoutStateProps = {
  flip: false,
  bookmarkedData: [...BookMarkData],
  pinedMenu: [],
  responsiveSearch: false,
  linkItemsArray: [],
};

const LayoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setFlip: (state) => {
      state.flip = !state.flip;
    },
    setPinedMenu: (state, action) => {
      state.pinedMenu = action.payload;
    },
    setResponsiveSearch: (state) => {
      state.responsiveSearch = !state.responsiveSearch;
    },
    handleBookmarkChange: (state, action) => {
      if (!action.payload.bookmarked) {
        state.bookmarkedData.push({ ...action.payload, bookmarked: !action.payload.bookmarked });
      } else {
        const tempt: BookmarkedDataType[] = [];
        state.bookmarkedData.forEach((ele) => {
          if (ele.id !== action.payload.id) {
            tempt.push(ele);
          }
        });
        state.bookmarkedData = tempt;
      }
      const temp = [...state.linkItemsArray];
      temp.splice(action.payload.id - 1, 1, { ...action.payload, bookmarked: !action.payload.bookmarked });
      state.linkItemsArray = temp;
    },
    handleStarredValue: (state, action) => {
      state.bookmarkedData = state.bookmarkedData.filter((data) => data.title !== action.payload.title);
    },
    getLinkItemsArray: (state, action) => {
      state.linkItemsArray = action.payload;
    },
  },
});
export const { setFlip, setPinedMenu, setResponsiveSearch, getLinkItemsArray, handleBookmarkChange, handleStarredValue } = LayoutSlice.actions;
export default LayoutSlice.reducer;
